import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserFullInfoService } from '../services/user-full-info.service';

export const canActivateManageMemberData: CanActivateFn = async () => {
  const userAccess = inject(UserFullInfoService);
  const router = inject(Router);

  await userAccess.loadUserInfo();

  return userAccess.canManageMemberDataSnapshot()
    ? true
    : router.createUrlTree(['/']);
};
